import { render, staticRenderFns } from "./UpdateAfssModalComponent.vue?vue&type=template&id=13a04006&"
import script from "./UpdateAfssModalComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateAfssModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAfssModalComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports